// eslint-disable-next-line no-shadow
export enum MusicVideoGenerationProcess {
	GENERATE_CHARACTER = 'generate_character',
	GENERATE_VIDEO = 'generate_video',
}
